import DashboardFloorMap from "./dashboardFloorMap";
export default DashboardFloorMap;
